module.exports = __webpack_public_path__ + "d5327099487df746f402c30466ae6e5b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/sounds/got-message.mp3
// module id = 1123
// module chunks = 0